export default "__VITE_ASSET__DAtc5lPW__"